import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ramadan20-rainbow-six-siege',
  templateUrl: './ramadan20-rainbow-six-siege.component.html',
  styleUrls: ['./ramadan20-rainbow-six-siege.component.css']
})
export class Ramadan20RainbowSixSiegeComponent implements OnInit {

  gameName = "rainbow-six-siege"
  constructor() { }

  ngOnInit() {
  }

}
